module.exports = __webpack_public_path__ + "img/gmeet.7de8f99f.svg";